import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import * as getTime from '~/skills/getTime';

import CircleCheckBox from '~/components/CheckBox/CircleCheckBox';
import { EAA_Item, EAA_ItemContainer, EAA_Select, EAA_Row, EAA_TitleText, EAA_Date, EAA_Input, EAA_ErrorText, EAA_Memo } from '~/components/EditAndAddItem';

import Sub4 from '../Sub4';
import Sub4IssueExplanation from './Task/Sub4IssueExplanation';

const industryDescriptionList = [
    { name: '返港', value: '返港' },
    { name: '暫停安裝', value: '暫停安裝' },
    { name: '進度調整', value: '進度調整' },
    { name: '進度延後', value: '進度延後' },
    { name: '其他', value: '其他' },
];
const analyzeList = [
    { name: '已完成', value: '已完成' },
    { name: '符合規劃', value: '符合規劃' },
    { name: '略為超前', value: '略為超前' },
    { name: '未符合規劃', value: '未符合規劃' },
];

const ExtraSchedule = (props) => {
    const { classes, titleWidth, disabled, returnInputValue, checkChange, changeData, data, z, errorBody, errorLeft } = props;
    // const zx = `${z}_`;
    const zx = '';

    useEffect(() => {
    }, []);

    return (
        <>
            <EAA_Row>
                <EAA_Item>
                    <EAA_ItemContainer>
                        <EAA_TitleText width={titleWidth} text='業者說明' bol={true} haveChange={checkChange(`${zx}industry_desc_status`)} />
                        <CircleCheckBox disabled={disabled} value={data[`${zx}industry_desc_status`] === '0'} onClick={() => changeData({ label: `${zx}industry_desc_status`, data: '0' })} />
                        <div style={{ marginLeft: 8, marginRight: 8 }}>無補充說明</div>
                        <CircleCheckBox disabled={disabled} value={data[`${zx}industry_desc_status`] === '1'} onClick={() => changeData({ label: `${zx}industry_desc_status`, data: '1' })} />
                        <div style={{ marginLeft: 8, marginRight: 8 }}>有補充說明</div>
                    </EAA_ItemContainer>
                    {errorBody[`${zx}industry_desc_status`] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
                </EAA_Item>
            </EAA_Row>

            {
                data[`${zx}industry_desc_status`] === '1' &&
                <>
                    <EAA_Row>
                        <EAA_Item>
                            <EAA_ItemContainer>
                                <EAA_TitleText width={titleWidth + 20} />
                                <div style={{ marginRight: 8 }}>因</div>
                                <EAA_Input displayBorder disabled={disabled} hint='詳答(選填)' marginRight={0} value={returnInputValue(data[`${zx}industry_desc_reason`])} onChange={data => changeData({ label: `${zx}industry_desc_reason`, data })} />
                                <div style={{ marginLeft: 8, marginRight: 8 }}>， 故</div>
                                <div style={{ width: 184, display: 'flex' }}><EAA_Select displayBorder disabled={disabled} list={industryDescriptionList} marginRight={0} value={returnInputValue(data[`${zx}industry_desc_method`])} onChange={data => changeData({ label: `${zx}industry_desc_method`, data })} /></div>
                                <div style={{ marginLeft: 8, marginRight: 50 }}>，</div>
                            </EAA_ItemContainer>
                        </EAA_Item>
                    </EAA_Row>

                    <EAA_Row>
                        <EAA_Item>
                            <EAA_ItemContainer>
                                <EAA_TitleText width={titleWidth + 20} />
                                <EAA_Memo displayBorder disabled={disabled} hint='詳答(選填)' value={returnInputValue(data[`${zx}industry_desc_note`])} onChange={data => changeData({ label: `${zx}industry_desc_note`, data })} />
                            </EAA_ItemContainer>
                        </EAA_Item>
                    </EAA_Row>
                </>
            }

            <EAA_Row>
                <EAA_Item>
                    <EAA_ItemContainer>
                        <EAA_TitleText width={titleWidth} text='議題說明' bol={true} haveChange={checkChange(`${zx}issue_desc_status`)} />
                        <CircleCheckBox disabled={disabled} value={data[`${zx}issue_desc_status`] === '0'} onClick={() => changeData({ label: `${zx}issue_desc_status`, data: '0' })} />
                        <div style={{ marginLeft: 8, marginRight: 8 }}>無議題說明</div>
                        <CircleCheckBox disabled={disabled} value={data[`${zx}issue_desc_status`] === '1'} onClick={() => changeData({ label: `${zx}issue_desc_status`, data: '1' })} />
                        <div style={{ marginLeft: 8, marginRight: 8 }}>有議題說明</div>
                    </EAA_ItemContainer>
                    {errorBody[`${zx}issue_desc_status`] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
                </EAA_Item>
            </EAA_Row>


            {data[`${zx}issue_desc_status`] === '1' && <Sub4IssueExplanation {...props} />}
            
            <EAA_Row>
                <EAA_Item>
                <EAA_ItemContainer>
                    <EAA_TitleText width={titleWidth} text='分析說明' bol={true} haveChange={checkChange(`${zx}admin_analysis_result`) || checkChange(`${zx}admin_analysis_date`) || checkChange(`${zx}admin_analysis_num`)} />
                    <EAA_Select displayBorder disabled={disabled} marginRight={0} value={returnInputValue(data[`${zx}admin_analysis_result`])} list={analyzeList} onChange={data => changeData({ label: `${zx}admin_analysis_result`, data })} />
                    {data[`${zx}admin_analysis_result`] === '未符合規劃' && <div style={{ marginLeft: 8, marginRight: 8 }}>{'(截至'}</div>}
                    {data[`${zx}admin_analysis_result`] === '未符合規劃' && <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data[`${zx}admin_analysis_date`])} onChange={data => changeData({ label: `${zx}admin_analysis_date`, data: getTime.getType3Time(data) })} marginRight={0} />}
                    {data[`${zx}admin_analysis_result`] === '未符合規劃' && <div style={{ marginLeft: 8, marginRight: 8 }}>落後</div>}
                    {data[`${zx}admin_analysis_result`] === '未符合規劃' && <EAA_Input displayBorder disabled={disabled} type='number' value={returnInputValue(data[`${zx}admin_analysis_num`])} onChange={data => changeData({ label: `${zx}admin_analysis_num`, data })} marginRight={0} />}
                    {data[`${zx}admin_analysis_result`] === '未符合規劃' && <div style={{ marginLeft: 8, marginRight: 50 }}>{'座)'}</div>}
                </EAA_ItemContainer>
                {errorBody[`${zx}admin_analysis_result`] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
                </EAA_Item>
            </EAA_Row>
        </>
    );
};

export default ExtraSchedule;
